<template>
  <v-card>
    <v-card-title class="justify-space-between mb-0 py-7">
      <span class="text-h5"><strong>Rejected Tissue Report</strong></span>
    </v-card-title>
    <v-row class="ml-2 mr-2 mb-3">
      <v-col cols="12" md="3">
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="filter.date_from"
          transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateFormateFrom" label="Start Date (Collection) : DD-MM-YYYY" readonly hide-details
              outlined dense v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="filter.date_from" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="$refs.menu.save('')">Clear </v-btn>
            <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(filter.date_from)"> OK </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3">
        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="filter.date_to"
          transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateFormateTo" label="End Date (Collection) : DD-MM-YYYY" readonly hide-details
              outlined dense v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="filter.date_to" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="$refs.menu1.save('')">Clear </v-btn>
            <v-btn text color="primary" @click="menu1 = false"> Cancel </v-btn>
            <v-btn text color="primary" @click="$refs.menu1.save(filter.date_to)"> OK </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="3" class="pl-0">
        <v-btn color="primary" class="mr-2" @click="reportExport()"> Export </v-btn>
        <v-btn color="primary" @click="refreshButton()">Reset</v-btn>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import FileSaver from 'file-saver'
import { api, apiUrl } from '@/config/config'
import moment from 'moment'
const localStoragedata = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
const token = localStoragedata.token
export default {
  data() {
    return {
      listLoading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
      filter: {
        date_from: '',
        date_to: ''
      },
      menu: false,
      menu1: false,
    }
  },
  computed: {
    dateFormateTo() {
      return this.filter.date_to ? moment(this.filter.date_to).format('DD-MM-YYYY') : ''
    },
    dateFormateFrom() {
      return this.filter.date_from ? moment(this.filter.date_from).format('DD-MM-YYYY') : ''
    },
  },
  methods: {
    refreshButton() {
      this.filter.date_from = ''
      this.filter.date_to = ''
    },
    async reportExport() {
      if (!this.filter.date_from || !this.filter.date_to) {
        this.snackbarText = 'Please Fill Date'
        this.snackbar = true
        return false
      }
      this.listLoading = true
      const data = {
        date_from: this.filter.date_from,
        date_to: this.filter.date_to,
      }
      try {
        const response = await api.post(`reports/rejected_tissue_report`, data, {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })
        if (response.data.message && response.data.message.startsWith('Successfully fetched')) {
          const value = apiUrl(response.data.path)
          const fileName = (response.data.path || '').split('/').pop() || 'rejected_tissue.xlsx'
          FileSaver.saveAs(value, fileName.replace(/\.(xlsx|docx)$/i, ''))
        }
        this.snackbarText = response.data.message
        this.snackbar = true
        this.listLoading = false
      } catch (e) {
        console.log(e)
        this.listLoading = false
      }
    },
  },
}
</script>
